'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TARGETED_MESSAGE = exports.TARGETED_MESSAGE = 'TARGETED_MESSAGE';
var QUALIFIED_LEAD = exports.QUALIFIED_LEAD = 'QUALIFIED_LEAD';
var PROMO_ANNOUNCEMENT = exports.PROMO_ANNOUNCEMENT = 'PROMO_ANNOUNCEMENT';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/constants/MessageTypes.js
// module id = 336
// module chunks = 2 3